var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row token-info" }, [
    _c("div", { staticClass: "col-6 col-md-4" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Número de Propuesta:")]),
      _c("span", { staticClass: "info" }, [
        _vm._v(" " + _vm._s(_vm.value.proposalNumber) + " ")
      ])
    ]),
    _c("div", { staticClass: "col-6 col-md-4" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Código de Evaluación:")]),
      _c("span", { staticClass: "info" }, [
        _vm._v(" " + _vm._s(_vm.value.token) + " ")
      ])
    ]),
    _c("div", { staticClass: "col-6 col-md-4" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Evaluador:")]),
      _c("span", { staticClass: "info" }, [
        _vm._v(" " + _vm._s(_vm.value.evaluator) + " ")
      ])
    ]),
    _c("div", { staticClass: "w-100 separator d-md-block" }),
    _c("div", { staticClass: "col-6 col-md-4" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Fecha Solicitado:")]),
      _c("span", { staticClass: "info" }, [
        _vm._v(" " + _vm._s(_vm._f("date")(_vm.value.date)) + " ")
      ])
    ]),
    _c("div", { staticClass: "col-6 col-md-4" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Tiempo de Expiración:")]),
      _c("span", { staticClass: "info" }, [
        _vm._v(" " + _vm._s(_vm._f("date")(_vm.value.expirationDate)) + " "),
        _c("b", [_vm._v(_vm._s(_vm._f("hour")(_vm.value.expirationDate)))])
      ])
    ]),
    _c("div", { staticClass: "col-6 col-md-4" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Lugar:")]),
      _c("span", { staticClass: "info" }, [
        _vm._v(" " + _vm._s(_vm.value.place) + " ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }